import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { MatButton } from '@angular/material';
import { Component } from '@angular/compiler/src/core';

@Directive({
  selector: '[button-access]'
})
export class ButtonAccessDirective implements OnInit {

  @Input() disableFor: string
  @Input() replaceWith: string = ''
  constructor(private authService: AuthenticationService,
    private el: ElementRef) { }

  ngOnInit(): void {

    if (this.authService.USER.roles.includes(this.disableFor)) {

      if (this.replaceWith == '') {
        this.el.nativeElement.remove()
      } else {
        var text = document.createElement("p")
        text.textContent = this.replaceWith
        text.style.cssText = 'border-width: 1px; border-style: outset; padding: 5px; min-width:100px; margin-top:10px; border-radius: 5px; color: gray'
        this.el.nativeElement.replaceWith(text)
      }


    }

  }

}
